import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import "../../../6729.css";

import image1 from "../../../images/motorcycle/motor-oil/6201/pictures_FF6201-1_green_front_1200.jpg";
import image2 from "../../../images/motorcycle/motor-oil/6201/pictures_FF6201-20_green_front_1200.jpg";
import image3 from "../../../images/motorcycle/motor-oil/6201/pictures_FF6201-60_green_front_1200.jpg";
import image4 from "../../../images/motorcycle/motor-oil/6201/pictures_FF6201-DR_green_front_1200.jpg";
import image5 from "../../../images/motorcycle/motor-oil/6201/pictures_FF6201-1_green_back_1200.jpg";
import image6 from "../../../images/motorcycle/motor-oil/6201/pictures_FF6201-20_green_back_1200.jpg";

import image7 from "../../../images/motorcycle/motor-oil/6201/pictures_FF6201-60_green_back_1200.jpg";
import image8 from "../../../images/motorcycle/motor-oil/6201/pictures_FF6201-DR_green_back_1200.jpg";


const images = [
  { src: image1, alt: "Front" },
  { src: image2, alt: "Back" },
  { src: image3, alt: "Front 4L" },
  { src: image4, alt: "Back 4L" },

];

const packageSlides = [
  { images: [image1, image5] },
  { images: [image2, image6] },
  { images: [image3, image7] }, 
  { images: [image4, image8] },  // 1L
  // 20L

];

const TDS_URL = "https://www.fanfaro.de/create-pdf/18";

const SDS_FILES = [
  { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(BE).pdf" },
  { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(BG).pdf" },
  { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(CZ).pdf" },
  { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(DE).pdf" },
  { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(DK).pdf" },
  { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(EE).pdf" },
  { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(ES).pdf" },
  { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(FI).pdf" },
  { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(FR).pdf" },
  { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(GR).pdf" },
  { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(HR).pdf" },
  { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(HU).pdf" },
  { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(IE).pdf" },
  { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(IT).pdf" },
  { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(LT).pdf" },
  { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(LV).pdf" },
  { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(NO).pdf" },
  { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(PL).pdf" },
  { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(PT).pdf" },
  { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(RO).pdf" },
  { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(RU).pdf" },
  { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(SE).pdf" },
  { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(SI).pdf" },
  { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF6201_-_FANFARO 6201 M-4T Plus_(SK).pdf" }
];

export default function ImageWithContent() {

  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showSDS, setShowSDS] = useState(false);

  const [packageIndex, setPackageIndex] = useState(0);
  const [imageIndex, setImageIndex] = useState(0);

  const slideInterval = useRef(null);
  const slideDuration = 4000;

  useEffect(() => {
    startSlideTimer();
    return () => clearInterval(slideInterval.current);
  }, []);

  const startSlideTimer = () => {
    slideInterval.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, slideDuration);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    clearInterval(slideInterval.current);
    startSlideTimer();
  };

  const nextImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev + 1) % total);
  };

  const prevImage = () => {
    const total = packageSlides[packageIndex].images.length;
    setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
  };

  return (
   <>
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: "32px",
        padding: "24px",
        fontFamily: "Arial",
      }}
    >

      {/* LEFT IMAGE CAROUSEL */}
       <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://amzn.in/d/04gJdSVL"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy on Amazon
          </button>
        </a>

      </div>

      {/* RIGHT CONTENT */}
      <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
        <h2>FANFARO M-4T Plus 6201</h2>

        <p>
          An innovative synthetic ester-containing engine oil for 4-stroke high-load engines of motorcycles, pit bikes, motards, etc. for off-road (enduro, motocross, trials, etc.) and highway (stuntriding, supermoto, etc.) driving under extreme loads. It was designed for a guaranteed protection of the engine and the durability of the gearbox.

        </p>

        <p><strong>Product properties:</strong></p>

        <ul style={{ paddingLeft: "20px" }}>
          <li>A special additive package and synthetic base ensure a high traction coefficient in friction elements, preventing wear, avoiding skidding, and allowing smooth clutch operation during starting, acceleration, and driving at constant speed, enabling easy gear shifts.</li>
          <li>The ester-containing base provides superior lubricating, anti-wear, and anti-scuffing properties, reducing fuel consumption, improving engine power, and extending service life. It offers maximum protection for the cylinder-piston group and valve gear.</li>
          <li>Designed with an exceptionally stable ester-containing synthetic base for extreme operating conditions, offering superior thermo-oxidative stability and high-temperature resistance while maintaining a strong oil film.</li>
          <li>High viscosity index ensures stable viscous properties under all operating conditions, including high sliding velocities, and enables exceptionally easy cold starts in winter.</li>
          <li>Special detergent-dispersion additives keep engine parts clean throughout operation.</li>
          <li>Excellent antifoam properties and low evaporation rate.</li>
          <li>High-performance inhibitors provide outstanding anticorrosion protection.</li>
          <li>Compatible with analogous synthetic oils.</li>
          <li>Fully compatible with all exhaust control systems.</li>
        </ul> <br />

        <p>
          It is designed for petrol-powered 4-stroke engines of motorcycles of all types, all-terrain vehicles (quadricycles), scooters and motor scooters with air and liquid cooling with or without an integrated gearbox, oil bath clutch coupling and “dry” clutch and other two-wheeled vehicles with and without catalytic converters that require operating properties to be of API SL or lower and JASO MA/MA2 level. <br />

          It is ideal for injection engines. <br />
          Comply with the manufacturer’s instructions provided in the user’s manual of the engine, especially the oil replacement age!
        </p>


        <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
          CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
        </p>

        {/* SPECIFICATIONS */}
        <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
          <div>
            <b>Specifications</b>
            <ul style={{ paddingLeft: "20px" }}>
              <li>SAE 10W-40</li>
              <li>API SL</li>
              <li>JASO MA/MA2</li>
            </ul>
          </div>


          <div>
            <b>Recommendation</b>
            {/*  */}
          </div>

          <div>
            <b>PACKAGES:</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(0);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  1L (FF6201-20)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(1);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  20L (FF6201-60)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(2);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  60L (FF6201-DR)
                </span>
              </li>

              <li>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setPackageIndex(3);
                    setImageIndex(0);
                    setShowModal(true);
                  }}
                >
                  208L (FF6201-IBC)
                </span>
              </li>

            </ul>
          </div>
          <div>
            <b>SDS & TDS</b>
            <ul style={{ paddingLeft: "20px" }}>

              <li>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowSDS(true);
                  }}
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  📄 SDS
                </a>
              </li>

              <li>
                <a
                  href="https://www.fanfaro.de/create-pdf/44"
                  target="_blank"
                  style={{ textDecoration: "none" }}>
                  🖨️ TDS
                </a>
              </li>

            </ul>
          </div>

        </div>



      </div>

      {/* MODAL */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "20px",
              width: "500px",
              borderRadius: "8px",
              position: "relative",
            }}
          >

            <span
              onClick={() => setShowModal(false)}
              style={{
                position: "absolute",
                right: "15px",
                top: "10px",
                cursor: "pointer",
                fontSize: "22px",
              }}
            >
              ✕
            </span>

            <img
              src={packageSlides[packageIndex].images[imageIndex]}
              alt="package"
              style={{
                width: "100%",
                maxHeight: "450px",
                objectFit: "contain",
              }}
            />

            <div style={{ textAlign: "center", marginTop: "20px" }}>

              <button onClick={prevImage}>◀</button>

              <span style={{ margin: "0 15px" }}>
                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
              </span>

              <button onClick={nextImage}>▶</button>

            </div>

          </div>
        </div>
      )}

      {showSDS && (
        <div className="sds-overlay" onClick={() => setShowSDS(false)}>
          <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
            {/* Close Icon */}
            <button
              className="sds-close-icon"
              onClick={() => setShowSDS(false)}
              aria-label="Close SDS"
            >
              ×
            </button>

            <h3>FANFARO M-4T Plus</h3>

            <div className="sds-grid">
              {SDS_FILES.map((file) => (
                <a
                  key={file.code}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {file.code}
                </a>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>

    <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
   </>
  );
}